var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1045 2224 c-313 -37 -524 -139 -724 -350 -363 -383 -397 -977 -80 -1405 64 -86 186 -202 276 -262 323 -215 741 -241 1092 -70 470 231 713 761 580 1271 -82 313 -320 592 -617 723 -165 72 -379 110 -527 93z m-22 -536 c45 -20 107 -77 107 -100 0 -6 13 7 29 29 77 107 269 131 479 60 62 -21 67 -25 81 -64 l15 -43 73 0 73 0 0 -490 0 -491 -72 6 c-40 4 -178 15 -307 24 -225 17 -235 17 -269 -1 -49 -25 -137 -24 -179 2 -32 19 -33 19 -325 -5 -161 -14 -303 -25 -315 -25 l-23 0 0 485 0 485 74 0 73 0 13 45 c15 52 21 57 110 80 147 38 276 39 363 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1540 c-22 -54 -22 -61 -20 -410 l3 -355 23 60 c22 59 22 67 20 410 l-3 350 -23 -55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702 1225 c-1 -321 1 -353 18 -390 19 -40 19 -39 17 315 -2 308 -4 360 -19 390 -16 33 -16 19 -16 -315z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769 1514 c20 -26 21 -37 21 -425 0 -373 -1 -399 -17 -399 -10 0 -132 7 -272 16 l-254 16 -42 -21 c-53 -26 -80 -26 -129 0 -38 20 -40 20 -280 5 -133 -9 -259 -16 -279 -16 l-37 0 0 402 c0 359 2 403 17 420 15 17 14 18 -20 18 l-37 0 0 -449 0 -449 38 4 c20 3 151 13 290 23 247 18 253 18 289 0 47 -24 99 -24 162 0 49 18 54 18 330 -3 l281 -22 0 453 0 453 -41 0 -40 0 20 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706 874 c-50 -7 -93 -17 -97 -21 -4 -5 -19 -34 -33 -65 l-25 -58 22 0 c12 0 120 7 240 16 210 16 219 16 252 -2 40 -21 52 -15 35 18 -26 49 -63 89 -100 108 -47 24 -156 26 -294 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264 866 c-28 -13 -63 -39 -78 -58 -42 -56 -30 -103 16 -61 18 16 34 16 265 0 135 -10 248 -15 251 -13 2 3 -7 29 -21 59 -23 51 -28 55 -73 66 -155 36 -291 39 -360 7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.8105fc60ff76e80a88346d28c221321a.svg";
export { ForwardRef as ReactComponent };